import './Layout.css';
import React, { createContext, useEffect, useRef, useState } from "react";
import {Outlet} from "react-router-dom";
import {AppBar, Box, Toolbar} from "@mui/material";
import {HashLink} from "react-router-hash-link";
import {ReactComponent as Logo} from "./images/logo-name.svg"
import {use100vh} from "react-div-100vh";
// import debounce from "lodash.debounce"; // 你需要安装 lodash 或单个 debounce 模块

export const ToCloseAllContext = createContext();

function Layout() {
    const [sections, setSections] = useState([]);
    const [works, setWorks] = useState([]);
    const [currentSection, setCurrentSection] = useState('home');
    const [closeToSection, setCloseToSection] = useState('');
    const [currentWork, setCurrentWork] = useState('');
    const isResizing = useRef(false);
    const logoRef = React.useRef(null);
    const viewHeight = use100vh();
    document.documentElement.style.setProperty('--100vh', viewHeight + 'px');
    const resizeTimerRef = useRef(null);
    const [toCloseAll, setToCloseAll] = useState(false);

    useEffect(() => {
        setSections(document.querySelectorAll('.section'));
        setWorks(document.querySelectorAll('.work-section'));
    }, []);

    const updateCurrentSection = () => {
        let current = ""
        let close = "";
        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top;
            if (parseInt(sectionTop) <= 0) {
                current = section.id;
            } else if (parseInt(sectionTop) <= 400) {
                close = section.id;
                // return;
            }
        });
        setCurrentSection(current);
        setCloseToSection(close);
    };


    const handleResize = () => {
        document.body.classList.add('no-animation');

        if (resizeTimerRef.current) {
            clearTimeout(resizeTimerRef.current);
        }

        resizeTimerRef.current = setTimeout(() => {
            document.body.classList.remove('no-animation');
            resizeTimerRef.current = null;
        }, 300);

    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const targetSection = document.querySelector(hash);
            if (targetSection) {
                targetSection.scrollIntoView({behavior: 'smooth'});
            }
        }
        window.addEventListener("scroll", updateCurrentSection);
        window.addEventListener("resize", handleResize);
    }, [sections]);

    // useEffect(() => {
    //     if (!toCloseAll) {
    //         setToCloseAll(true);
    //     }
    // }, [currentSection])

    const handleClickOnNavLink = (event) => {
        // setToCloseAll(true);
    }

    useEffect(() => {

        const updateNavLinks = () => {
            const header = document.querySelector('.header');
            const navLinks = document.querySelectorAll('.nav-links a');
            const logo = logoRef.current;

            navLinks.forEach(link => {
                link.classList.remove('active-section');
                link.classList.add('inactive-section');
                if (link.getAttribute('href') === "/#" + currentSection || link.getAttribute('href') === "/#" + currentSection.replace("banner-", "")) {
                    link.classList.add('active-section');
                    link.classList.remove('inactive-section');
                }
            });

            if (header) {
                if (currentSection === "work" || currentSection === "contact" || currentSection === "banner-work" || closeToSection === "work" || currentSection === "banner-contact") {
                    header.classList.add('header-dark');
                    header.classList.remove('header-light');
                    logo.classList.add('header-dark');
                    logo.classList.remove('header-light');
                    if (currentSection === "contact") {
                        logo.classList.add('logo-last');
                        header.classList.add('header-contact');
                    } else {
                        logo.classList.remove('logo-last');
                        header.classList.remove('header-contact');
                    }
                } else {
                    header.classList.add('header-light');
                    header.classList.remove('header-dark', 'header-contact');
                    logo.classList.add('header-light');
                    logo.classList.remove('header-dark', 'logo-last');
                }
            }
        }

        updateNavLinks();
    }, [currentSection, closeToSection, sections]);

    return (
        <ToCloseAllContext.Provider value={{ toCloseAll: toCloseAll, setToCloseAll: setToCloseAll }}>
        <div className={"app"}>
                <HashLink to={"/#home"} className={"nav-text"} onClick={handleClickOnNavLink}>
                    <Logo ref={logoRef} className={"logo"}/>
                </HashLink>
                <Box className={"header"} sx={{display: 'flex'}}>
                    <AppBar position="static">
                        <Toolbar>
                            <div className={"header-div nav-links"}>
                                <HashLink to="/#home" className={"active-section nav-text"} onClick={handleClickOnNavLink}>Home</HashLink>
                                <HashLink to="/#work" className={"inactive-section nav-text"} onClick={handleClickOnNavLink}>Work</HashLink>
                                <HashLink to="/#contact" className={"inactive-section nav-text"} onClick={handleClickOnNavLink}>Contact</HashLink>
                            </div>
                        </Toolbar>
                    </AppBar>
                </Box>
                <Box component="main" sx={{p: 3}} className={"homepage-container"}>
                    <Outlet/>
                </Box>
            </div>
        </ToCloseAllContext.Provider>
    );
}

export default Layout;